<template>
  <li v-if="user.company" class="rent-pre-registrations-messages-menu dropdown">
    <audio ref="newRents" :src="cdn('sound.mp3')"></audio>
    <audio ref="newRentSound" :src="cdn('beep.mp3')"></audio>
    <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
      <i class="fa fa-fw fa-lg fa-comments-o"></i><span v-if="unreadMessages && unreadMessages.count > 0" class="bell-badge">{{ unreadMessages.count }}</span>
    </a>
    <ul class="dropdown-menu">
      <template v-if="unreadMessages && unreadMessages.messages.length > 0">
        <li class="dropdown-header">Mensagens não lidas</li>
        <template  v-for="message in unreadMessages.messages">
          <li role="separator" class="divider"></li>
          <li>
            <router-link :to="{name: 'orders_list', query: {orderId: message.order_id, tab: (message.received ? 'received' : 'made')}}">
              <div class="pull-right text-silver font-10">{{ message.created_at | time }}</div>
              <small v-if="message.chat" class="text-silver"><b>{{ message.client }}</b></small>
              <small v-else class="text-silver"><b>{{ message.fantasy_name }}</b></small>
              <div v-for="(m, i) in message.messages" :key="i">
                <br><span v-html="m"></span>
              </div>
              <br><div class="text-right text-silver font-10">#{{ message.order_id }} - {{ message.sku_title }}</div>
            </router-link>
          </li>
        </template>
      </template>
      <li v-else class="dropdown-header">Nenhuma mensagem não lida no momento</li>
    </ul>
  </li>
</template>

<script>
  import {mapState, mapActions} from 'vuex'

  export default{
    name: 'ChatMenu',
    components: {},
    data () {
      return {
        interval: false
      }
    },
    computed: {
      ...mapState({
        unreadMessages: state => state.unreadMessages,
        user: state => state.user
      })
    },
    mounted () {
      this.getRentsPreRegistrationsMessages()
      this.listenEvents()
      this.interval = setInterval(this.playAlertSound, 5 * 60000)
    },
    beforeDestroy () {
      clearInterval(this.interval)
    },
    methods: {
      playAlertSound () {
        if (this.unreadMessages.count > 0) {
          this.$refs.newRents.play()
        }
      },
      setUnreadMessages (unreadMessages) {
        this.changeUnreadMessages(unreadMessages)
        if (unreadMessages.count > this.unreadMessages.count) {
          setTimeout(() => {
            this.$refs.newRentSound.play()
          }, 1)
        }
      },
      getRentsPreRegistrationsMessages () {
        this.loading = true
        this.loadRentPreRegistrationsMessagesCount({companyId: this.user.company.id})
          .then((response) => {
            this.setUnreadMessages(response.data)
            this.loading = false
          }, (error) => {
            console.log(error)
            this.loading = false
          })
      },
      listenEvents () {
        window.Channel.listen('.App\\Events\\NewMessages', (e) => {
          this.setUnreadMessages(e)
        })
        window.Channel.listen('.App\\Events\\NewChatMessages', (e) => {
          this.setUnreadMessages(e)
        })
      },
      ...mapActions([
        'loadRentPreRegistrationsMessagesCount',
        'changeUnreadMessages'
      ])
    }
  }
</script>


// WEBPACK FOOTER //
// ChatMenu.vue?41a5ad4c